module.exports = __webpack_public_path__ + "static/media/CallIcon.44aaad91.svg";